import { BlueRadio } from "components/common";
import { useActuatorConfigurationContext } from "context/ActuatorConfigurationContext";
import { useCallback, useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { ActuatorCommandMode } from "types/Actuator";
import { checkAllowLevelOnly } from "utils/actuatorFunctions";

const ModeOptions = () => {
    const {
        editedActuator,
        editedActuator: { mode },
        setEditedActuator,
        isIOControllerState: { appId, isIOController, mode: ioMode },
        gatewayId,
        ldsuId,
    } = useActuatorConfigurationContext();

    const [allowLevelOnly, setAllowLevelOnly] = useState(false);

    const IsAllowLevelOnly = useCallback(
        () => checkAllowLevelOnly({ isIOController, appId, gatewayId, ldsuId }),
        [gatewayId, ldsuId, appId, isIOController]
    );

    useEffect(() => {
        const checkLevelOnlyMode = async () => {
            const result = await IsAllowLevelOnly();
            setAllowLevelOnly(result);
        };

        checkLevelOnlyMode();
    }, [IsAllowLevelOnly]);

    const handleActuatorMode = (item: string) => {
        switch (item.toUpperCase()) {
            case ActuatorCommandMode.LEVEL:
                {
                    const { timing, ...rest } = editedActuator;
                    const updatedActuator = {
                        ...rest,
                        mode: ActuatorCommandMode.LEVEL,
                    };
                    setEditedActuator(updatedActuator);
                }
                break;
            case ActuatorCommandMode.PULSE:
                setEditedActuator({
                    ...editedActuator,
                    timing: [[0, 0]],
                    mode: ActuatorCommandMode.PULSE,
                });
                break;
            case ActuatorCommandMode.LOOP:
                setEditedActuator({
                    ...editedActuator,
                    timing: [[0, 0]],
                    mode: ActuatorCommandMode.LOOP,
                });
                break;
            case ActuatorCommandMode.PWM:
                setEditedActuator({
                    ...editedActuator,
                    timing: [
                        [0, 0],
                        [0, 0],
                    ],

                    mode: ActuatorCommandMode.PWM,
                });
                break;
        }
    };

    const modeList = () => {
        if (ioMode) {
            return ioMode;
        } else if (!isIOController) {
            return ["Level", "Pulse"];
        }
        return [];
    };
    return (
        <>
            {modeList().length > 0 && (
                <>
                    <Form.Label className="mt-2 mb-3">Mode</Form.Label>
                    <Form.Row className="sensor-mode mb-5">
                        {modeList().map((item: string) => (
                            <Col md={2} key={item}>
                                <BlueRadio
                                    name="mode"
                                    id={item}
                                    checked={mode === item.toUpperCase()}
                                    custom
                                    type="radio"
                                    label={<span className="ml-2">{item}</span>}
                                    onChange={() => handleActuatorMode(item)}
                                    disabled={
                                        allowLevelOnly &&
                                        item.toUpperCase() !==
                                            ActuatorCommandMode.LEVEL
                                    }
                                />
                            </Col>
                        ))}
                    </Form.Row>
                </>
            )}
        </>
    );
};

export default ModeOptions;
